var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import paging from './paging';
import pagingStyle from "./paing.module.css";
export const DEMO_PADDING = 4;
export const DEMO_FOOTER_HEIGHT = 50;
let ComponentDemo = class ComponentDemo extends Vue {
  render() {
    var _this$designer$$scope, _this$designer$$scope2;
    const h = arguments[0];
    return h("div", {
      "class": "ucd-component-button-demo",
      "style": {
        left: this.demoStyle.left,
        top: this.demoStyle.top
      },
      "on": {
        "mouseenter": this.handleMouseenter,
        "mouseleave": this.handleMouseleave
      }
    }, [h("div", {
      "class": "ucd-component-button-demo-content"
    }, [this.renderDemo()]), (_this$designer$$scope = this.designer.$scopedSlots) === null || _this$designer$$scope === void 0 || (_this$designer$$scope2 = _this$designer$$scope.componentDemoLink) === null || _this$designer$$scope2 === void 0 ? void 0 : _this$designer$$scope2.call(_this$designer$$scope, {
      componentId: this.componentId
    })]);
  }
  handleMouseenter() {
    this.$emit('demoMouseEnter');
  }
  handleMouseleave() {
    this.$emit('demoMouseLeave');
  }
  renderDemo() {
    const h = this.$createElement;
    const scopedSlots = {
      customPaging: ({
        i
      }) => {
        var _this$demo$extra;
        return h(paging, {
          "attrs": {
            "currentIndex": i,
            "size": ((_this$demo$extra = this.demo.extra) === null || _this$demo$extra === void 0 ? void 0 : _this$demo$extra.length) || 0 + 1
          }
        });
      }
    };
    if (this.demo.extra) {
      return h("a-carousel", {
        "attrs": {
          "autoplay": true,
          "dots-class": `${pagingStyle.dots}`
        },
        "style": `width: ${this.demoStyle.maxWidth}; height: ${this.demoStyle.maxHeight}`,
        "scopedSlots": scopedSlots
      }, [this.renderCarouselContent(this.demo), this.demo.extra.map(demo => this.renderCarouselContent(demo))]);
    }
    return this.renderImg(this.demo.src, this.demoStyle.maxHeight, this.demoStyle.maxWidth);
  }
  renderCarouselContent(demo) {
    const h = this.$createElement;
    return h("div", [h("div", {
      "style": {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: this.demoStyle.maxHeight,
        width: this.demoStyle.maxWidth
      }
    }, [h("div", {
      "style": {
        width: `${demo.info.width / 2}px`,
        height: `${demo.info.height / 2}px`,
        maxHeight: '100%',
        maxWidth: '100%'
      }
    }, [this.renderImg(demo.src, this.demoStyle.maxHeight, this.demoStyle.maxWidth)])])]);
  }
  renderImg(src, height, width) {
    const h = this.$createElement;
    return h("img", {
      "attrs": {
        "height": "auto",
        "width": "auto",
        "src": src
      },
      "style": {
        height: height || 'auto',
        width: width || 'auto',
        'object-fit': 'contain'
      }
    });
  }
};
ComponentDemo = __decorate([Component({
  name: 'ComponentDemo',
  props: {
    demo: {
      type: Object,
      default: null
    },
    demoStyle: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: ''
    }
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  components: {
    paging
  }
})], ComponentDemo);
export default ComponentDemo;
//# sourceMappingURL=index.js.map
